import { createAction } from '@reduxjs/toolkit';
import {
  Restreamer,
  RestreamingConfig,
  RestreamingFailurePayload,
  RestreamingStartedPayload,
  RestreamingStopRequestedPayload,
} from 'features/restreamer/types';

export const restreamingToggled = createAction<boolean | undefined>(
  'restreamer/restreamingToggled'
);

export const requestRestreaming = createAction<RestreamingConfig>('restreamer/request');
export const signalingRestreamingRequested = createAction('signaling/restreamer/requested');
export const signalingRestreamingStarted = createAction<RestreamingStartedPayload>(
  'signaling/restreamer/started'
);

export const stopRestreamer = createAction('restreamer/stop');
export const signalingRestreamingStopRequested = createAction<
  RestreamingStopRequestedPayload | undefined
>('signaling/restreamer/stopRequested');
export const signalingRestreamingFailure = createAction<RestreamingFailurePayload | undefined>(
  'signaling/restreamer/failure'
);
export const signalingRestreamingStopped = createAction('signaling/restreamer/stopped');

export const signalingRestreamerJoined = createAction<Restreamer>('signaling/restreamer/joined');
